import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "女主播分类" },
  { to: "/videos", label: "视频专辑" },
  { to: "/gallery", label: "写真图库" },
  { to: "/about", label: "关于我们" },
];

const hotTags = ["新闻主播", "娱乐主播", "综艺主播", "首尔", "红毯写真", "音乐节目"];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-secondary-100 mt-16">
      <div className="px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center text-background-50">
              <i className="ri-live-line text-xl"></i>
            </span>
            <span className="font-heading font-bold text-lg text-background-50">韩国女主播</span>
          </div>
          <p className="text-sm text-secondary-200/80 leading-relaxed">
            韩国女主播资讯门户，专注聚合最新主播动态、个人资料、视频专辑与高清写真，带你全面了解韩国女主播圈内信息。
          </p>
        </div>

        <div>
          <h4 className="text-background-50 font-heading font-semibold mb-4">网站导航</h4>
          <ul className="space-y-2 text-sm">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-secondary-200/80 hover:text-accent-300 transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-background-50 font-heading font-semibold mb-4">热门标签</h4>
          <div className="flex flex-wrap gap-2">
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/category?q=${encodeURIComponent(tag)}`}
                className="px-3 py-1 rounded-full text-xs bg-secondary-800 text-secondary-100 hover:bg-accent-500 hover:text-background-50 transition-colors"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-background-50 font-heading font-semibold mb-4">关注我们</h4>
          <p className="text-sm text-secondary-200/80 mb-3">
            投稿、合作与内容纠错欢迎随时联系。
          </p>
          <div className="flex items-center gap-3">
            <a href="https://luaviet.asia" rel="nofollow" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-accent-500 transition-colors">
              <i className="ri-weibo-fill"></i>
            </a>
            <a href="https://luaviet.asia" rel="nofollow" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-accent-500 transition-colors">
              <i className="ri-youtube-fill"></i>
            </a>
            <a href="https://luaviet.asia" rel="nofollow" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-accent-500 transition-colors">
              <i className="ri-instagram-line"></i>
            </a>
            <a href="https://luaviet.asia" rel="nofollow" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-accent-500 transition-colors">
              <i className="ri-tiktok-fill"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-secondary-300/70">
          <p>© 2026 韩国女主播 Star Channel. 本站内容为演示示例，仅供学习交流。</p>
          <p>友情链接：内容合作 · 品牌推广 · 数据服务</p>
        </div>
      </div>
    </footer>
  );
}